export const setAndReportValidity = (
  element: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement,
  message: string
) => {
  element.setCustomValidity(message);
  element.reportValidity();
  setTimeout(() => element.setCustomValidity(''), 1500);
};

export default setAndReportValidity;
